import {
    receive_audiences,
    update_ns_preference,
    receive_ns_preferences,
    update_ns_preferences,
} from "../../reducers/DMP/reducer";
import {
    getUserAudiences,
    filterAudiences,
    deserializePreference,
} from "./utils/library";
import * as CONSTANTS from "./constants";
import log from "../../utils/logger/library";
import { saveLocalPreference } from "./utils/library";
import { getDetailsForSegments } from "dmp-audiences";

/**
 * @param {string} namespace
 * @param {Array.<string>} keys
 * @param {boolean} [overwrite=true] if false, becomes a nop if preferences already exist
 */
export const fetch_namespace_preferences = (
    namespace,
    keys,
    overwrite = true
) => {
    return (dispatch, getState) => {
        if (!overwrite && getState().dmp.preferences[namespace]) {
            return;
        }

        let prefix = CONSTANTS.LS_KEY_PREFIX_BY_NAMESPACE[namespace];
        let preferences = {};
        keys.forEach((key) => {
            let value = deserializePreference(prefix + key.toUpperCase());
            if (value !== undefined) {
                preferences[key] = value;
            }
        });
        dispatch(receive_ns_preferences({ namespace, preferences }));
    };
};

/**
 * @param {string} namespace
 * @param {string} key
 * @param {boolean} value
 * @param {boolean} isRemote
 */
export const update_namespace_preference = (
    namespace,
    key,
    value,
    isRemote
) => {
    return (dispatch) => {
        if (!isRemote) {
            saveLocalPreference(namespace, key, value);
        }

        dispatch(update_ns_preference({ namespace, key, value }));
    };
};

/**
 *
 * @param {string} namespace
 * @param {object} preferences
 */
export const update_namespace_preferences = (namespace, preferences) => {
    return (dispatch) => {
        try {
            Object.entries(preferences).forEach(([key, value]) => {
                saveLocalPreference(namespace, key, value);
            });
        } catch (err) {
            log.error(
                `(update_namespace_preferences) Failed to save ${namespace} preferences`,
                err
            );
        }

        dispatch(update_ns_preferences({ namespace, preferences }));
    };
};

/**
 * cbc-stats-top.js fetches audience data and stores it in a global variable
 * using JSONP to bypass same-origin policy.
 * This function will read the response from this API call.
 *
 * @returns {Promise} The dispatch function
 */
export function fetch_audience() {
    return async (dispatch, getState) => {
        if (getState().dmp.audienceSegmentsLoaded) {
            return;
        }

        let userAudiences;
        let adAudiences = [];
        try {
            userAudiences = await getUserAudiences();
            adAudiences = filterAudiences(userAudiences, ["Ads", "Dfp"]);
        } catch (error) {
            log.error("Failed to get audiences", error);
        } finally {
            const audienceSegments = getDetailsForSegments(userAudiences) ?? [];
            dispatch(receive_audiences({ audienceSegments, adAudiences }));
        }
    };
}
